import React from 'react'
import { ScreenReaderOnly } from '@moonpig/launchpad-components'
import { TextChatMessage } from '../../ChatMessages/types'
import { UserMessageStyledBox, UserMessageText } from './styled'

export const UserMessage = ({
  msg,
  id,
}: {
  msg: TextChatMessage
  id: number
}) => {
  const labelId = `chat-user-message-label-${id}`
  const contentId = `chat-user-message-content-${id}`

  return (
    <UserMessageStyledBox
      aria-labelledby={`${labelId} ${contentId}`}
      data-testid="chat-user-message"
      role="article"
    >
      <ScreenReaderOnly id={labelId}>You: </ScreenReaderOnly>
      <UserMessageText id={contentId}>{msg.content}</UserMessageText>
    </UserMessageStyledBox>
  )
}
